import { createContext } from 'react';

const AboutusScreenContext = createContext( null );

export default AboutusScreenContext;